import * as Types from './types';

const INITIAL_STATE = {
  user: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.LOGIN_USER:
      return {
        ...state,
        user: action.user,
      };
    case Types.LOGOUT_USER:
      return {
        ...state,
        user: null,
      };
    case Types.USER_DOTASK:
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
};
